import { Link, useLoaderData } from "react-router";
import type { LoaderFunctionArgs } from "react-router";
import { getDiscipline } from "../lib/disciplines";
import { getPortfoliosByDiscipline } from "../lib/portfolios";
import site from "../content/site.json";

export function meta({ data }: { data: Awaited<ReturnType<typeof loader>> }) {
  return [{ title: `${data.discipline.title} — Captures by Mari` }];
}

export async function loader({ params }: LoaderFunctionArgs) {
  const discipline = getDiscipline(params.discipline!);
  if (!discipline) throw new Response("Not found", { status: 404 });
  return { discipline, portfolios: getPortfoliosByDiscipline(discipline.slug) };
}

export default function DisciplineLanding() {
  const { discipline, portfolios } = useLoaderData<typeof loader>();
  return (
    <main className="max-w-7xl mx-auto px-6 py-12">
      <header className="flex flex-wrap items-end justify-between gap-6 mb-10 md:mb-14">
        <h1 className="page-title">{discipline.title}</h1>
        <Link to="/work" className="font-camera text-xs text-primary hover:underline">All photos →</Link>
      </header>
      <div className="grid md:grid-cols-2 gap-6">
        {portfolios.map((portfolio) => (
          <Link key={portfolio.slug} to={`/work/${discipline.slug}/${portfolio.slug}`} className="relative block">
            <img src={portfolio.coverImage} alt={portfolio.title} className="w-full aspect-[4/5] object-cover" />
            <div className="photo-caption flex justify-between gap-4">
              <h2>{portfolio.title}</h2>
              <span>{portfolio.images.length} photos →</span>
            </div>
          </Link>
        ))}
      </div>
      {portfolios.length === 0 && <p className="text-muted-foreground">No photos here yet. <a href={site.instagram} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Message me on Instagram ↗</a></p>}
    </main>
  );
}
